module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.370dd5a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-regular-400.ttf
// module id = 1moO
// module chunks = 2